export default "__VITE_ASSET__0ab3939c__"